import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceGql: DocumentNode = gql`
fragment FlowsDisplayGridRowDataFragmentWithoutPersonalSpace on Flow {
  id
  name
  vizportalUrlId
  # Commented out until the backend can handle these subqueries.
  #  downstreamWorkbooksConnection {
  #   totalCount
  #  }
  projectVizportalUrlId
  projectName
  owner {
    domain
    username
    name
  }
}
`;
